import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export interface BhMenuItem {
  value: string;
  label: string;
  icon?: string;
}

export const propsOptions = {
  value: {
    type: String,
    default: '',
  },
  menuItems: {
    type: Array as PropType<BhMenuItem[]>,
    required: true,
  },
};

export const emitsOptions = {
  'update:value': (_value: string) => true,
};

export default /*#__PURE__*/_defineComponent({
  __name: 'BhBaseMenu',
  props: propsOptions,
  emits: emitsOptions,
  setup(__props) {





return { __sfc: true,propsOptions, emitsOptions, MaterialIcon }
}

})